import { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components/macro';
import { useDetectClickOutside } from 'react-detect-click-outside';
import { Flex, Box, ClickableBox } from 'components/ui';
import chevronUp from 'img/chevron-up.svg';
import chevronDown from 'img/chevron-down.svg';
import futuraSpec from 'utils/futuraSpec.json';

interface MixInputProps {
  name: string;
  value: number | string;
  onChange: (e: ChangeProps) => void;
  options: number[];
}

interface ChangeProps {
  target: {
    name: string;
    value: string;
  };
}

const Option = styled(Flex)`
  cursor: pointer;

  &:hover {
    background-color: black;
  }
`;

const TempoSelect = ({ name, value, onChange, options }: MixInputProps) => {
  const [open, setOpen] = useState(false);

  const ref = useDetectClickOutside({
    onTriggered: () => setOpen(false),
  });

  const onSelect = useCallback(
    value => {
      onChange({
        target: {
          name,
          value,
        },
      });
    },
    [name, onChange]
  );

  useEffect(() => {
    if (options.length === 0) return;

    if (value === '' || value === -1) {
      onSelect(futuraSpec.tempo.indexOf(options[0]));
      return;
    }

    const selectedTempo = futuraSpec.tempo[value];

    if (selectedTempo && !options.includes(selectedTempo)) {
      onSelect(futuraSpec.tempo.indexOf(options[0]));
    }
  }, [value, options, onSelect]);

  return (
    <Box position="relative" mb={[2, 0]}>
      <ClickableBox ref={ref} mr={2} color="white" onClick={() => setOpen(!open)}>
        <Flex
          background={open ? '#222' : 'black'}
          width="140px"
          height="32px"
          px={2}
          borderRadius="3px"
          alignCenter
        >
          <Box mr={3}>{futuraSpec.tempo[value]} BPM</Box>
          <img alt=">" src={open ? chevronUp : chevronDown} width="14px" />
        </Flex>
      </ClickableBox>
      {open && (
        <Box
          position="absolute"
          zIndex={89}
          top="32px"
          left="0"
          width="140px"
          background="#444"
          overflowY="scroll"
          borderRadius="3px"
          p={1}
        >
          {options.map(tempo => (
            <Option
              p={1}
              key={tempo}
              width="100%"
              onClick={() => onSelect(futuraSpec.tempo.indexOf(tempo))}
              alignCenter
            >
              {tempo} BPM
            </Option>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default TempoSelect;
